import { cn } from '@/lib/cn'

export function StatusDot({
  status,
  label,
  pulse = false,
  className,
}: {
  status: 'online' | 'offline' | 'degraded' | 'unknown'
  label?: string
  pulse?: boolean
  className?: string
}) {
  const tones = {
    online: 'bg-success',
    offline: 'bg-danger',
    degraded: 'bg-warning',
    unknown: 'bg-subtle-foreground',
  }

  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      <span className="relative flex size-2 shrink-0">
        {pulse && status !== 'unknown' && (
          <span
            className={cn(
              'absolute inline-flex size-full animate-ping rounded-full opacity-60',
              tones[status],
            )}
            aria-hidden
          />
        )}
        <span className={cn('relative inline-flex size-2 rounded-full', tones[status])} />
      </span>
      {label && <span className="text-muted-foreground text-[12px]">{label}</span>}
    </span>
  )
}
